/* eslint-disable no-unused-vars */
import React from 'react';
import useAnalytics from '../../hooks/useAnalytics';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import Restricted from '../../authorization/Restricted';
import routes from '../../config/routes';

function LeftBarMainItem({
  name, path, icon, permission, closeDrawer, collapsed,
}) {
  const { pathname } = useLocation();
  const { setAnalytics } = useAnalytics();

  // Mapea el path a section_id de analytics
  const getSectionId = () => {
    switch (path) {
      case '/statistics/deviceOverview': return 'device_management-overview';
      case '/statistics/brandConsumptions': return 'device_management-consumptions';
      case '/statistics/deviceInfo': return 'device_management-info';
      case '/statistics/deviceSettings': return 'device_management-settings';
      case '/statistics/deviceRawData': return 'device_management-raw_data';
      case '/statistics/brandEvents': return 'device_management-events';
      case '/statistics/moduleSettings': return 'device_management_moduleSettings'
      case '/assets': return 'asset_management-assets';
      case '/bundles': return 'asset_management-bundles';
      case '/deployments': return 'asset_management-deployments';
      case '/waves': return 'asset_management-waves';
      case '/cloudToDevice': return 'message_simulator-cloud_to_device';
      case '/reports': return 'iot_reports';
      case '/support': return 'service_request';
      default: return null;
    }
  };

  const handleClick = (e) => {
    console.log('path =>', path);
    const sectionId = getSectionId();
    if (sectionId) {
      setAnalytics({
        event: 'section_loaded',
        sectionId,
      });
      console.log(`[Analytics] section_loaded: ${sectionId}`);
    }
    closeDrawer && closeDrawer(e);
  };

  const isThisLocation = (localPath) => pathname.substring(0, localPath.length) === localPath;

  const isSelected = () => {
    // Handle root path - should select Overview (Device Management)
    if (pathname === '/' && path === '/statistics/deviceOverview') {
      return true;
    }
    
    // Handle deployment creation routes based on source parameter
    if (pathname.includes('/deployments/create/asset') && path === '/assets') {
      return true; // Highlight Assets when creating deployment from asset
    }
    if (pathname.includes('/deployments/create/bundle') && path === '/bundles') {
      return true; // Highlight Bundles when creating deployment from bundle
    }
    
    // If no specific location is matched, default to 'Device Overview'
    if (routes.find((route) => route.path === pathname) === undefined) {
      return path === '/statistics/deviceOverview'; // Default to deviceOverview if no other path is matched
    }
    return isThisLocation(path);
  };

  const selectedClasses = 'bg-blue-500 text-white'; // Example Tailwind classes for selected state
  const hoverClasses = 'hover:bg-blue-500 hover:text-white'; // Example Tailwind classes for hover state

  return (
    <Restricted to={[permission]}>
      <Link
        to={path}
        key={name}
        onClick={handleClick}
        id={`listItem${name.replaceAll(' ', '')}`}
        title={collapsed ? name : undefined}
        className={`flex items-center ${collapsed ? 'justify-center' : ''} p-2 min-h-[48px] ${hoverClasses} ${isSelected(path) ? selectedClasses : ''}`}
      >
        {icon && <span className={`${collapsed ? '' : 'mr-3'} min-w-[24px]`}>{icon}</span>}
        {!collapsed && <span className="flex-grow font-light">{name}</span>}
        {/* <ArrowRightIcon className="h-5 w-5" /> */}
      </Link>
    </Restricted>
  );
}

LeftBarMainItem.propTypes = {
  name: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  icon: PropTypes.element, // Icon is now optional as it's commented out
  permission: PropTypes.string.isRequired,
  closeDrawer: PropTypes.func.isRequired,
  collapsed: PropTypes.bool,
};

LeftBarMainItem.defaultProps = {
  collapsed: false,
};

export default LeftBarMainItem;
